import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static targets = ['button', 'spinner', 'idleLabel', 'loadingLabel']

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly spinnerTarget: HTMLElement
  declare readonly idleLabelTarget: HTMLElement
  declare readonly loadingLabelTarget: HTMLElement
  declare readonly hasButtonTarget: boolean
  declare readonly hasSpinnerTarget: boolean
  declare readonly hasIdleLabelTarget: boolean
  declare readonly hasLoadingLabelTarget: boolean

  submit (event: Event): void {
    const form = this.element
    if (!form.checkValidity()) {
      event.preventDefault()
      return
    }

    this.start()
  }

  start (): void {
    this.toggleLoadingState(true)
  }

  stop (): void {
    this.toggleLoadingState(false)
  }

  private toggleLoadingState (isLoading: boolean): void {
    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = isLoading
    this.buttonTarget.classList.toggle('pointer-events-none', isLoading)
    this.buttonTarget.ariaBusy = isLoading.toString()

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle('hidden', !isLoading)
    }

    this.toggleLabels(isLoading)
  }

  private toggleLabels (isLoading: boolean): void {
    if (this.hasIdleLabelTarget) {
      this.idleLabelTarget.classList.toggle('hidden', isLoading)
    }

    if (this.hasLoadingLabelTarget) {
      this.loadingLabelTarget.classList.toggle('hidden', !isLoading)
    }
  }
}
